export enum ASK_ENUM {
  /** 不询问 */
  NO_ASK = 1,
  /** 询问 */
  ASK = 2
}

export interface GetUserConfigResProps {
  askEveryTime: ASK_ENUM
  content: string
}

/** 零售书默认配置 */
export const DEFAULT_RECETIPT_BOOK_VALUE: GetUserConfigResProps = {
  askEveryTime: ASK_ENUM.ASK,
  content: ''
}

/** 解析接口返回的数据 */
export const responseReceiptData = (res?: string): GetUserConfigResProps => {
  if (typeof res !== 'string') {
    return DEFAULT_RECETIPT_BOOK_VALUE
  }
  const lastUseData = JSON.parse(res)
  return lastUseData
}
